import topimg from '../../../asset/images/ibaimages/topimg.svg';
import '../../IBA/commonComp/commonIba.scss'
const OverviewTopCard = ({ cardObj, onClick, isActive }) => {
    console.log(cardObj, "cardObj");

    return (
        <div className='card-main'>
            <div 
            // className="card-iba"
            className={`card-iba ${isActive ? "active-card" : ""}`}
            onClick={onClick}
            >
                <img src={cardObj.img} alt="topimg" height="40px" width="40px" />
                <div className="value-leb">
                    <span className="value">{cardObj.value}</span>
                    <span className="leble">{cardObj.leble}</span>
                </div>
            </div>
        </div>
    )
}

export default OverviewTopCard
